import FadeLoader from "react-spinners/FadeLoader";

export const FadeSpinner = ({ color = "DD2626", size = 30 }) => {
  return <FadeLoader color={color} loading="true" height={size} margin={8} />;
};
